import "../../../shared/styles/form.css";
import "./styles.css";

import {
  Button,
  Col,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { serviceTypeListAsync } from "../../../features/serviceType/serviceTypeListSlice";
import { getAllAdmins } from "../../../services/adminApi";
import { createPriceBetweenRegions } from "../../../services/priceApi";
import { getRegions } from "../../../services/regionsApi";
import { InlineForm } from "../../../shared/components/InlineForm";
import { WebRoutes } from "../../../shared/constants/WebRoutes";
import ContainerLayout from "../../common/containerLayout";
import CreateItemsServices from "./CreateItemsServices";
import { getCurrencies } from "../../../services/currencyApi";

const { Title } = Typography;

export const PriceForm = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [servicePrices, setServicePrices] = useState<
    {
      id: number;
      name: string;
      price: number;
      stopsPrice: number;
      timesPrice: number;
      driverPrice: number;
    }[]
  >([]);
  const [admins, setAdmins] = useState([]);
  const [regions, setRegions] = useState<{ value: number; label: string }[]>(
    [],
  );

  const [loading, setLoading] = useState(false);
  const serviceTypes = useAppSelector((x) => x.serviceTypeList.value);
  const [currencies, setCurrencies] = useState([]);

  const getAdminsData = async () => {
    const admins = await getAllAdmins();
    const mappedAdmins = admins.map((a: any) => ({
      value: a.id,
      label: a.name,
    }));
    setAdmins(mappedAdmins);
  };

  const getServices = async () => {
    await dispatch(serviceTypeListAsync());
  };

  const getRegionsData = async () => {
    const data = await getRegions();
    const mappedRegions = data.map((r) => ({ value: r.id, label: r.name }));
    setRegions(mappedRegions);
  };

  const fecthCurrencies = async () => {
    const data = await getCurrencies();
    const mappedCurrencies = data.map((currency: any) => ({
      value: currency.id,
      label: `${currency.code} - ${currency.name}`,
    }));

    setCurrencies(mappedCurrencies);
  };

  useEffect(() => {
    getAdminsData();
    getRegionsData();
    getServices();
    fecthCurrencies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onFinish = async (values: any) => {
    const { companyIds, driverPrice, priority } = values;
    setLoading(true);

    try {
      const body = {
        ...values,
        driverPrice: driverPrice ?? null,
        companyIds: companyIds ?? null,
        priority: priority,
        pricesByServices: servicePrices,
      };

      await createPriceBetweenRegions(body);

      navigate(WebRoutes.PricesRoute, {
        replace: true,
      });
    } catch (error: any) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <ContainerLayout
      title="Configuración de precio por regiones"
      showNotification={false}
    >
      <Col span={12}>
        <Form
          form={form}
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          autoComplete="off"
          id="itemForm"
        >
          <InlineForm>
            <Form.Item
              name="origin"
              label="Region A"
              rules={[
                { required: true, message: "Por favor ingresa un nombre!" },
              ]}
            >
              <Select
                placeholder="Seleccione una región"
                showSearch
                options={regions}
                optionFilterProp="label"
              />
            </Form.Item>
            <Form.Item
              name="destination"
              label="Region B"
              rules={[
                { required: true, message: "Por favor ingresa un nombre!" },
              ]}
            >
              <Select
                placeholder="Seleccione una región"
                showSearch
                options={regions}
                optionFilterProp="label"
              />
            </Form.Item>
          </InlineForm>
          <InlineForm>
            <Form.Item
              label="Prioridad"
              name="priority"
              rules={[
                {
                  required: true,
                  message: "Por favor ingresa una prioridad!",
                },
              ]}
            >
              <InputNumber<number> />
            </Form.Item>
            <Form.Item
              name="currencyId"
              label="Moneda"
              rules={[
                { required: true, message: "Por favor selecciona una moneda!" },
              ]}
            >
              <Select
                placeholder="Seleccione una moneda"
                showSearch
                options={currencies}
                optionFilterProp="label"
              />
            </Form.Item>
          </InlineForm>

          <InlineForm>
            <Form.Item
              label="Precio"
              name="price"
              rules={[
                { required: true, message: "Por favor ingresa un precio!" },
              ]}
            >
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={1}
              />
            </Form.Item>
            <Form.Item label="Precio conductor" name="driverPrice">
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={0}
              />
            </Form.Item>
          </InlineForm>

          <Form.Item name="companyIds" label="Empresas">
            <Select
              mode="multiple"
              placeholder="Seleccione una empresa"
              showSearch
              options={admins}
              optionFilterProp="label"
            />
          </Form.Item>
          <InlineForm>
            <Form.Item label="Precio por paradas" name="additionalStopPrice">
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={0}
              />
            </Form.Item>
            <Form.Item
              label="Precio por paradas conductor"
              name="additionalStopDriverPrice"
            >
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={0}
              />
            </Form.Item>
          </InlineForm>
          <InlineForm>
            <Form.Item
              label="Precio por minuto de espera"
              name="waitingMinutePrice"
            >
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={0}
              />
            </Form.Item>
            <Form.Item
              label="Precio por minuto de espera conductor"
              name="waitingMinuteDriverPrice"
            >
              <InputNumber<number>
                formatter={(value) =>
                  `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                parser={(value) => Number(value!.replace(/\$\s?|(,*)/g, ""))}
                min={0}
              />
            </Form.Item>
          </InlineForm>

          <Form.Item
            label="Tolerancia de minutos de espera"
            name="waitingGraceMinutes"
          >
            <InputNumber<number> min={0} />
          </Form.Item>

          <Form.Item>
            <Space direction="horizontal">
              <Button type="primary" htmlType="submit" loading={loading}>
                Guardar
              </Button>
              <Button
                onClick={() =>
                  navigate(WebRoutes.PricesRoute, {
                    replace: true,
                  })
                }
              >
                Cancelar
              </Button>
            </Space>
          </Form.Item>
        </Form>
      </Col>

      <Col span={12}>
        <Row justify="center">
          <Title level={2}>Precios por servicios</Title>
        </Row>

        <CreateItemsServices
          servicePrices={servicePrices}
          setServicePrices={setServicePrices}
          serviceTypes={serviceTypes}
        />
      </Col>
    </ContainerLayout>
  );
};

export default PriceForm;
